import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/404.svg")